"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRuleSetRevisionV1Serializer = void 0;
const msgpack_1 = require("@msgpack/msgpack");
const getRuleSetRevisionV1Serializer = () => ({
    description: 'RuleSetRevisionV1',
    fixedSize: null,
    maxSize: null,
    serialize: (revision) => (0, msgpack_1.encode)(revision),
    deserialize: (buffer, offset = 0) => {
        const ruleSet = (0, msgpack_1.decode)(buffer.subarray(offset + 1));
        const newOffset = offset + buffer.length;
        if (Array.isArray(ruleSet)) {
            return [
                {
                    libVersion: ruleSet[0],
                    owner: ruleSet[1],
                    ruleSetName: ruleSet[2],
                    operations: ruleSet[3],
                },
                newOffset,
            ];
        }
        return [ruleSet, newOffset];
    },
});
exports.getRuleSetRevisionV1Serializer = getRuleSetRevisionV1Serializer;
//# sourceMappingURL=revision.js.map